<template>
  <v-container class="tiles" pa-0>
    <v-row>
      <div class="page__title page__title--welcome">
        <div>
          <h1 class="mb-0">Witaj</h1>

          <p class="home__username">{{ profile.firstName }}</p>
        </div>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12" xl="3" lg="4" md="6" sm="12">
        <v-card v-ripple flat class="home-tile home-tile--special home-karta-tile">
          <card-view />

          <card-info />
        </v-card>
      </v-col>

      <v-col cols="12" xl="9" lg="8" md="6" sm="12">
        <v-card v-ripple flat class="home-tile home-tile--special home-event-tile">
          <event-home />
        </v-card>
      </v-col>
    </v-row>

    <v-layout row wrap fill-height>
      <v-flex v-for="(tile, index) in tiles" :key="'tile_ ' + index" col>
        <router-link class="home-tile-link" :to="{ name: tile.routeName }">
          <tile :icon="tile.icon" :title="tile.title" :text="tile.text" />
        </router-link>
      </v-flex>
    </v-layout>
    <popup />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import Tile from '@/components/base/Tile';
import Popup from '@/components/popup/Popup';

import CardInfo from '@/components/cards/CardInfo';
import CardView from '@/components/cards/CardView';
import { mainRouting } from '@/utils/mainRouting';
import EventHome from '@/components/cards/EventHome';
// @vuese
// Widok główny
// @group views
export default {
  name: 'Home',
  components: { Tile, Popup, CardInfo, CardView, EventHome },
  data() {
    return {
      tiles: mainRouting.filter(tile => tile.routeName !== 'card')
    };
  },
  computed: mapState({ profile: state => state.profile.data })
};
</script>

<style>
.tiles a {
  text-decoration: none;
}
</style>
